<template>
  <div class="content">
    <md-card>
      <!-- <md-card-header data-background-color="green">
            <h4 class="title">Shifokor bo'limi</h4>
          </md-card-header> -->
      <md-card-content>
        <b-container fluid>

          <div class="tables">
            <b-table
              class="tableStyle"
              id="room-table"
              ref="refUserTable"
              hover
              striped
              primary-key="id"
              :items="items"
              :fields="translatedFields"
              :filter="filter"
              :per-page="perPage"
              :current-page="currentPage"
              :filter-included-fields="filterOn"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @row-clicked="RowClicked"
              sort-icon-left
              stacked="md"
              show-empty
              small
              @filtered="onFiltered"
            >
            </b-table>
            <div style="background-color: blue; padding: 4px; font-weight: bold; border-radius: 10px; width: 100%; height: 30px; color: #fff; display: grid; grid-template-columns: repeat(3,1fr); ">
              <div>
                <p>Умумий</p>
              </div>
              <div style="margin-left: 100px;">
               <p>{{ this.count }}</p>
              </div>
              <div style="margin-left: 20px;">
                <p>{{this.summa}}</p>
              </div>
            </div>
          </div>

          <b-row>
            <b-col sm="6" offset-sm="3" md="6" offset-md="3" class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-container>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "UserIndex",
  components: {},
  data() {
    return {
      items: [],
      count:0,
      summa:0,
      fields: [
        "№",
        { key: "name", label: "Номи", sortable: true },
        { key: "count", label: "Сони", sortable: true },
        { key: "summa", label: "Нархи", sortable: true },
      ],
      translatedFields: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: ["name"]
    };
  },
  watch: {
    "$i18n.locale": {
      immediate: true,
      handler() {
        this.updateTranslatedFields();
      }
    }
  },
  mounted() {
    this.updateTranslatedFields();
    this.data();
  },
  methods: {
    updateTranslatedFields() {
      this.translatedFields = this.fields.map(field => {
        return {
          ...field,
          label: this.$t(field.label)
        };
      });
    },
    RowClicked(item) {
      this.$router.push({ path: "/dorilar-update/" + item.id });
    },
    dorilarLink(id) {
      return this.$router.push({ path: "dorilar-update/" + id });
    },
    createRoomLink() {
      return this.$router.push({ path: "dorilar-create" });
    },
    data() {
      let s = this;
      axios({
        method: "get",
        url: "/prixod/tovar"
      }).then(res => {
        console.log("Tovar",res)
        if (res != undefined) {
          s.items = res.data.data;
          const son = 0 ;
          for(let  i of s.items){
            console.log("count", i)
            this.count =   i.count + this.count
            this.summa =   i.summa + this.summa
          }
          s.totalRows = s.items.length;
        }
      });
    },
    Data() {
      let self = this;
      axios({
        method: "post",
        url: "/pill/search",
        data: {
          name: self.filter
        }
      }).then(res => {
        if (res != undefined) {
          self.items = res.data.data;
          self.totalRows = self.items.length;
        }
      });
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    trash(id) {
      const trash = window.confirm(this.$t("Малумотлар ўчирилсинми?"));
      if (trash) {
        let self = this;
        axios({
          method: "delete",
          url: "/pill/delete/" + id
        }).then(res => {
          if (res != undefined) {
            self.data();
          }
        });
      }
    }
  }
};
</script>
<style>
.qidiruv {
  display: flex;
  justify-content: space-between;
}
.tables {
  overflow-y: auto;
  overflow-x: hidden;
  height: 1000px;
}
.content {
  margin-top: -60px;
}
.qoshishBtn {
  display: flex;
  border-radius: 8px;
}
.pencil {
  width: 35px;
  height: 35px;
  display: flex;
  background: #fff;
  border: 1px solid #e9f1fa;
  justify-content: center;
  border-radius: 50%;
  align-items: center;
}
.trash {
  background: #fff;
  width: 35px;
  height: 35px;
  display: flex;
  border: 1px solid #fff0f0;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
</style>
